/* Complete your Set — slider scroll-snap con flechas */
(function () {
  function initSlider(section) {
    if (!section || section.getAttribute('data-cys-init') === 'true') return;
    section.setAttribute('data-cys-init', 'true');

    var track = section.querySelector('[data-cys-track]');
    var arrows = section.querySelector('[data-cys-arrows]');
    var prev = section.querySelector('[data-cys-prev]');
    var next = section.querySelector('[data-cys-next]');

    if (!track || !prev || !next) return;

    function stepSize() {
      var slide = track.querySelector('.complete-your-set__slide');
      if (!slide) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function scrollByStep(direction) {
      track.scrollBy({ left: stepSize() * direction, behavior: 'smooth' });
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var hasOverflow = maxScroll > 2;

      section.classList.toggle('has-slider', hasOverflow);
      if (arrows) arrows.hidden = !hasOverflow;

      prev.disabled = !hasOverflow || track.scrollLeft <= 2;
      next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
    }

    prev.addEventListener('click', function () {
      scrollByStep(-1);
    });

    next.addEventListener('click', function () {
      scrollByStep(1);
    });

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    // el ancho cambia al cargar imágenes o al redimensionar
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }

    update();
  }

  function initAll(context) {
    var scope = context || document;
    [].slice.call(scope.querySelectorAll('[data-complete-your-set]')).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
